import {Component} from '@angular/core';
import {DocumentListComponent} from '../document-list/document-list.component';

@Component({
    selector: 'app-document-collection',
    templateUrl: './document-collection.component.html',
    styleUrls: ['./../document-list/document-list.component.scss', './document-collection.component.scss']
})
export class DocumentCollectionComponent extends DocumentListComponent {

    public tableType = 'collection';
    public isCreateCollection = true;
    public isCreateFolder = false;


    editCollection(key: 'name' | 'collection_description', value: string): void {
        const data = {
            collection_description: this.response.folder.description,
            name: this.response.folder.name,
        };

        data[key] = value;

        this.docAPI.editCollection(this.response.folder.id, data).subscribe({
            next: () => {
                this.controller.loadNav(this.pagination);
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    blockCollection(): void {
        this.docAPI.lockCollection(this.response.folder.id, !this.response.folder.is_locked).subscribe({
            next: () => {
                this.controller.loadNav(this.pagination);
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}
